import { InputNumber as AntdInputNumber } from "antd";
import { InputNumberProps as AntdInputNumberProps } from "antd/lib/input-number";
import React from "react";

export type MyInputNumberProps = AntdInputNumberProps;

const InputNumberPolyfill: React.FC<MyInputNumberProps> = (props) => {
  return <AntdInputNumber {...props} />;
};

export default InputNumberPolyfill;
